import { render, staticRenderFns } from "./activity-form.vue?vue&type=template&id=2fbd01d8&scoped=true&"
import script from "./activity-form.vue?vue&type=script&lang=js&"
export * from "./activity-form.vue?vue&type=script&lang=js&"
import style0 from "./activity-form.vue?vue&type=style&index=0&id=2fbd01d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd01d8",
  null
  
)

component.options.__file = "activity-form.vue"
export default component.exports